"use client";
import { useRememberedPhone } from "./useRememberedPhone";

export function RememberedPhoneInput() {
  const [phone, setPhone] = useRememberedPhone();
  return <input required name="phone" type="tel" inputMode="numeric" pattern="1[3-9][0-9]{9}" maxLength={11} autoComplete="username" placeholder="请输入手机号"
    value={phone} onChange={event => setPhone(event.target.value)}
    className="rounded-xl border border-[var(--color-line-strong)] bg-[var(--color-sunken)] px-4 py-3" />;
}
